/**
 * * МОдель запроса на добавление видео
 */
export default class AddVideoBatchItem  {
	/**
	 * * Название файла
	 */
	FileName!: string;
	/**
	 * * Размер файла
	 */
	FileSize!: number;
	/**
	 * * Превью для видео (миниатюра)
	 */
	Thumbnail!: string;
	constructor(obj?: Partial<AddVideoBatchItem>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
